<script>
// This component should redirect window as soon as it's rendered, and
// does not render any markup of its own.
export default {
  props: {
    points: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      routing: false
    }
  },

  computed: {
    redirectUrl() {
      return `/api/local/${this.points[0].id}/item_url?type=${this.points[0].type}`
    }
  },

  mounted() {
    window.location.href = this.redirectUrl
  }
}
</script>
